import { startCase } from 'lodash';

import { validDirectDebitNumber } from '@/common/Validators';
import { OrgSubscription } from './organisation';

export const PAYMENT_TYPES = ['directDebit', 'directInvoice', 'farmSource', 'ruralCo'] as const;

export type PaymentType = typeof PAYMENT_TYPES[number];

export function isPaymentType(x: unknown): x is PaymentType {
	return typeof x === 'string' && PAYMENT_TYPES.indexOf(x as PaymentType) !== -1;
}

export const formatPaymentMethod = (type: PaymentType): string => startCase(type);

export const formatAccountNumber = (accountNumber: string): string =>
	validDirectDebitNumber(accountNumber) ? '••••••••••••' : accountNumber;

export const hasAccountFields = (type: PaymentType): boolean => type !== 'directInvoice';

export const setPaymentMethodConstraints = (subscription: OrgSubscription) => {
	if (subscription.paymentMethod === 'directInvoice') {
		subscription.accountApproved = true;
		subscription.paymentMethodActive = true;
	}
};

export const paymentMethodError = (type: PaymentType): string => {
	switch (type) {
		case 'directDebit': {
			return 'A direct debit number must in a 12-1234-1234567-12 or 12-1234-1234567-123 format (dashes included)';
		}
		case 'farmSource': {
			return 'A Farmsource number must be 9 digits long, no spaces';
		}
		case 'ruralCo': {
			return 'A Ruralco number must be in either R1234567, R12345678, 1234 or 12345 format';
		}
		default:
			return '';
	}
};

export interface OrgPaymentMethodResponse {
	data: OrgPaymentMethod[];
}

export interface OrgPaymentMethod {
	id: number;
	orgId: number;
	type: PaymentType;
	accountName: string;
	accountNumber: string;
	active: boolean;
	approved: boolean;
	createdAt: string;
	updatedAt: string;
	billToOrgId?: number;
	deletedAt?: string;
}

export interface PaymentMethodCreateParams {
	orgId: number;
	type: PaymentType;
	approved: boolean;
	active: boolean;
	accountName?: string;
	accountNumber?: string;
	billToOrgId?: number;
}

export interface PaymentMethodType {
	type: PaymentType;
	billToOrgId?: number;
}
